import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import EDITLogo from "../../../assets/images/edit.png";
import editLogoSVG from "../../../assets/images/edit_icon.svg";
import { params, const_var, } from "../reducer.js";
import { genratePrintImages, setPricingForComponent,showDoorWindowsPrompt,setPriceForCupola, updateDoorWindowPosition, capturebuildingImages, /* showAlert */ } from "../../../action/index.js";
import { SendBuildingDatatoServer } from "../../../action/quote_order/leadcustomer.action.js";
import { SendBuildingDatatoPublicServer, onQuoteSubmitApi } from "../../../action/quote_order/quote.action.js";
import * as cuBuilding from "../building_pricing/pricingReducer.js";
import axios from "axios";
import store from "../../store/index.js";
import TWEEN from "@tweenjs/tween.js";
import { SVGLoader } from "three/examples/jsm/loaders/SVGLoader";
import CSG from "../../../assets/libs/three-csg.js";
import shutterWindowTexture from '../../../assets/images/imgTextures/buildingImages/shutterWindowTexture.jpeg';
import { convertToAdjustedFeetInches,isCheckCustomSizeInRange } from  '../utils.js'
import { makeTranslucent } from "../../../helpers/building/building_config/componentConfig.js";
import { addValidation, cupolaEditValidation, cupolaValidation } from "../../../utils/Validation.js";
import { captureBlobImages, isAllCaptured } from "../../../action/extra_options/orderExtras.action.js";
import { controls } from "../common/eventReducer.js";
import { getCamDstForSelectedWall } from "../../../utils/Functions.js";
import { saveOqImageService } from "../../../services/quote-order.service.js";
import { shouldUseEntryPosition } from "../../../helpers/building_component/doorWindows.helper.js";
import { addCupola } from "../../../helpers/building_component/buildingComponent.helper.js";

export const handleComponentPositionOnDimensionChange = () => {};
let intersectedWall = null;
export const componentState = {
    updateStateAccordingtoCondition: "",
    updateNewAction: "",
    layout2DMapId: 0,
    generated2DMapId: null
};
const componentReducer = (state = componentState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "genrateBlobImage":
            action.event.preventDefault();
            const_var.checkIval = 0;
            const_var.i_g_A_y = [];
            TsCeSot("quote", "", "test");
            return {
                ...state,
                updateStateAccordingtoCondition: action + state.updateNewAction,
            };
        case "prepareTwoDMapData":
            const_var.layout2DMapId = (state.layout2DMapId + 1) % 65536;
            const_var.generated2DMapId = null;
         
            return {
                ...state,
                layout2DMapId: (state.layout2DMapId + 1) % 65536,
            };
        case "generatedTwoDMapData":
            const_var.generated2DMapId = action.payload;
            return {
                ...state,
                generated2DMapId: action.payload,
            };
        default:
            break;
    }
    return newState;
};

/*********************  Giorgi  ************************* */
export const loadDoorComponentOnWall = (compType, compName, wallName, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,parentOBJ, isBreezewayFrame, breezewayUniqueI, selectedCmpPosX, selectedCmpPosY, isChangePos, isLandTshapeDoor, pTrimkit,is_default_door) => {
    let componentdimension = (is_edit != undefined) ? componentsize.name.split("x") : componentsize.split("x");
    const width = (compType == "garage_door" || compType == "garage_door_frameout") ? parseInt(componentdimension[0]) : parseInt(componentdimension[0]) / 12;
    const height = (compType == "garage_door" || compType == "garage_door_frameout") ? parseInt(componentdimension[1]) : parseInt(componentdimension[1]) / 12;
        let is_addedBuilding_location = ""
        if(wallName.includes("G_R")) {
            is_addedBuilding_location = "right"
        }
        if(wallName.includes("G_L")) {
            is_addedBuilding_location = "left"
        }
        if(wallName.includes("G_F")) {
            is_addedBuilding_location = "front"
        }
        if(wallName.includes("G_B")) {
            is_addedBuilding_location = "back"
        }
        
    const validationVariable = addValidation({ compType, compName, width, height, wallName, parentkey, childkey, nestedkey });
    let isAdd = validationVariable.isAdd;
    const minLimitX = validationVariable.minLimitX;
    const maxLimitX = validationVariable.maxLimitX;
    const minLimitY = validationVariable.minLimitY;
    const maxLimitY = validationVariable.maxLimitY;
    let finalValueX = convertToAdjustedFeetInches(validationVariable.positionX, minLimitX, maxLimitX)
    let finalValueY = convertToAdjustedFeetInches(validationVariable.positionY, minLimitY, maxLimitY)
    let positionX = finalValueX;
    let positionY = (compType == "window" || compType == "window_frameout") ? finalValueY: validationVariable.positionY;
    const newArray = validationVariable.newArray;
    if (isChangePos === false && (selectedCmpPosX !== undefined && selectedCmpPosY !== undefined)) {
        positionX = selectedCmpPosX;
        if (compType === "window" || compType === "window_frameout") positionY = selectedCmpPosY;
    }
    //  Set Default position of component
    if (is_default_door  &&  entry_position && shouldUseEntryPosition(compType)) {
         positionX = entry_position.positionX;
        positionY = entry_position.positionY;
        positionY = compType == "garage_door" || compType == "walkin" ?  positionY: entry_position.positionY;
      }
    if (is_edit != undefined ) {
        positionX = entry_position.positionX;
        if((compType === "window" || compType === "window_frameout")){
            positionY = entry_position.positionY;
        }

    const overlapped = const_var.newDoorsArray.filter((door) => door.userData.wallName == wallName).find((item) => {
            if (((item.positionX + item.width / 2) >= (positionX - width / 2)) && ((item.positionX - item.width / 2) <= (positionX + width / 2)) &&
               ((item.positionY + item.height / 2) >= (positionY - height / 2)) && ((item.positionY - item.height / 2) <= (positionY + height / 2))) {
                  return item;
            }  
      })

    if (overlapped) isAdd = false;
    if((positionX < minLimitX) || (positionX > maxLimitX)) isAdd = false;
        const_var.sum++;
    }
    
    let wallOffset = ((wallName == "c_b_r_w" && params.leanStyle.right == "gable" && params.leantoAlignmentRight == 2) ||
                     (wallName == "c_b_l_w" && params.leanStyle.left == "gable" && params.leantoAlignmentLeft == 1))
                     ? 1 : -1
    if(isLandTshapeDoor) positionX = ((params.p_d / -2) + (params.lean_p_w / 2)) * wallOffset

    if(!isAdd && isChangePos === undefined)
    {
        if (const_var.isFromCompareForCompChk) {
            const_var.isShowAlert = true;
            const_var.alertUsedFor = "noClearanceForComponent";
            const_var.checkDoorIsadded = false;
        } else {
            store.dispatch(showDoorWindowsPrompt(compType, compName, width, height, wallName));
            const_var.checkDoorIsadded = false;
        }

        const_var.isFromCompareForCompChk = false;
    }
    if (isAdd || (isChangePos !== undefined)) {
        let tempArray = [...newArray];
        const newUniqueId = const_var.newDoorsArray.length > 0 ? const_var.newDoorsArray[const_var.newDoorsArray.length - 1].uniqueId + 1 : 0;
     
        const wallComponent = {
            uniqueId: newUniqueId,
            parent_array_key: parentkey,
            child_array_key: childkey,
            nested_array_key: nestedkey,
            size: (is_edit!=undefined)?componentsize.name:componentsize,
            actual_val: width + "x" + height,
            DoorObj: { 
                "trimkit": componentsize.entry_trim_kit!=undefined?componentsize.entry_trim_kit:pTrimkit, 
                "chain_hoist": componentsize.entry_chain_hoist!=undefined?componentsize.entry_chain_hoist:params.chain_hoist, 
                "header_seal": componentsize.entry_header_seal!=undefined?componentsize.entry_header_seal:params.header_seal, 
                "certified_door": componentsize.entry_certified!=undefined?componentsize.entry_certified:params.certified_door, 
                "entry_note": componentsize.entry_note!=undefined?componentsize.entry_note:params.extra_notes, 
                "garage_door_color": (is_edit!=undefined && componentsize?.entry_garageDoor_color_Obj!=undefined)?componentsize.garage_door_color?.replace("0x","#"):(params.g_d_c?.includes("0x"))?params.g_d_c.replace("0x","#"):'#ffffff', 
                "automatic_openers": componentsize.entry_automatic_openers!=undefined?componentsize.entry_automatic_openers:params.automatic_openers,
                "insulated":componentsize.entry_insulated!=undefined?componentsize.entry_insulated:params.insulated,
            },
            userData: {
                compType,
                wallName,
                uniqueId: newUniqueId,
                compName,
                isBreezewayFrameOut: false,
                cuttingFeatureAvailable: true,
            },
            doorColor: parentkey == "Walk" ? "#ffffff": (is_edit!=undefined && componentsize?.entry_garageDoor_color_Obj!=undefined)?componentsize?.garage_door_color.replace("0x","#"):(params?.g_d_c?.includes("0x"))?params.g_d_c.replace("0x","#"):'#ffffff', 
            width,
            height,
            positionX,
            positionY,
            is_edit,
            parentOBJ, 
            entry_position,
            entry_rotation,
            isBreezewayFrame, 
            breezewayUniqueI,
            isCustomSizeChange: false,
            minLimitX,
            maxLimitX,
            entryNoteData: '',
            position: {positionX, positionY},
            name: compName + newUniqueId 
        }
        if(params.m_s_n == 9 && wallComponent.parent_array_key == 'Walk'){
            wallComponent.DoorObj['threshold'] = componentsize.threshold!=undefined?componentsize.threshold:params.threshold
        }
        tempArray.push(JSON.parse(JSON.stringify(wallComponent)));
        
        const_var.doorUniqueId = newUniqueId;
        const_var.newDoorsArray = JSON.parse(JSON.stringify(tempArray));

        var kk = 0;
        var kd = 0;
        var kw = 0;
        let calQuantity = 0;
        const isBreezewayFrameOut = ((isBreezewayFrame !== undefined && isBreezewayFrame == 'isBreezewayFrame'));
        let wallCheckForEnd = false, wallCheckForSide = false;

        if(const_var.entry_wall_location[wallName].includes('end')==true  && const_var.entry_wall_location[wallName] != "rfend" && const_var.entry_wall_location[wallName] != "lfend" )
        {
            wallCheckForEnd = true;
        }

        if(const_var.entry_wall_location[wallName].includes('side')==true  || const_var.entry_wall_location[wallName] == "rfend" || const_var.entry_wall_location[wallName] == "lfend")
        {
            wallCheckForSide = true;
        }
        
        if (compType == "window" || compType == "window_frameout") {
            kw++;
            calQuantity = kw;
        }

        if (compType == "walkin" || compType == "walkin_frameout") {
            kd++;
            calQuantity = kd;
        }

        if (is_edit != undefined) {
            let currentObjData = componentsize;
            let doorAddOnsObj = {};
            let doornewType = "";
            if (currentObjData.child_array_key == "overhead_door_door" || currentObjData.child_array_key == "panel_garage_door_door") {
                Object.keys(currentObjData).map((e) => {
                    if (e.includes("add_on_options"))  {
                        doorAddOnsObj[e] = currentObjData[e];
                    }
                })
                
            }

            
            
            if (currentObjData.entry_motor) {
                 const motors = currentObjData.entry_size.door_add_ons?.filter((e) => e.door == "motor");
                if(motors && motors.length > 0) {
                    const motor = motors[0].category.filter((e) => e.category == currentObjData.entry_motor_name);
                    if (motor.length == 0) {
                        if(motors[0].category.length > 0) {
                            currentObjData.entry_motor_name = motors[0].category[0].category;
                            currentObjData.entry_motor_price = motors[0].category[0].cost;
                        }else {
                            currentObjData.entry_motor = false;
                        }
                    }
                } else {
                    currentObjData.entry_motor = false;
                }
            }
            if(currentObjData.child_array_key=="overhead_door_door")
            {
                 const wOPtion = currentObjData.entry_size.door_add_ons?.filter((e) => e.door == 'window_option');
                if (wOPtion && wOPtion.length > 0) {
                    const doorName = compName.replace("overhead_door_door_", '');
                    doornewType = wOPtion[0].category.find((item) => item.category.split(' ').join('_').toLowerCase() == doorName);
                    if(doornewType!='')
                    {
                        doorAddOnsObj.entry_overhead_type_name = (doornewType!=undefined)?doornewType.category:'';
                        doorAddOnsObj.entry_overhead_type_price = (doornewType!=undefined)?doornewType.cost:'';
                    }
                }
            }
            
            if (parentkey == "Garage" || parentkey == "Garage_Frameout") {

                if(params.m_s_n == 87 && const_var.isFromPickThis && currentObjData.entry_header_seal == false && currentObjData.entry_size.is_header_seal){
                    params.header_seal = true
                    currentObjData.entry_header_seal = true;
                    wallComponent.DoorObj.header_seal = true;
                    currentObjData.entry_header_seal_price = currentObjData.entry_size.header_seal
                }

                if ((params.m_s_n == 3 || params.m_s_n == 9) && currentObjData.entry_header_seal == true && currentObjData.entry_automatic_openers == true) {
                    if (const_var.isFromCompare) {
                        currentObjData.entry_header_seal = false;
                        wallComponent.DoorObj.header_seal = false;
                    }
                }
                
                if(wallComponent.DoorObj!=undefined && wallComponent.DoorObj!=null)
                {
                    if(wallComponent.DoorObj.installation_is_end_wall==undefined)
                    {
                        wallComponent.DoorObj.installation_is_end_wall = currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'';
                    }
                    if(wallComponent.DoorObj.installation_is_side_wall==undefined)
                    {
                        wallComponent.DoorObj.installation_is_side_wall = currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'';
                    }
                }
                let newDoorData = const_var.newDoorsArray.filter(data=>data.uniqueId==newUniqueId);
                if(newDoorData.length>0 && (currentObjData.door_type == "overhead_door_door" || currentObjData.door_type == "panel_garage_door_door"))
                {
                    newDoorData[0].userData.compName = compName;
                }
                kk++;
                calQuantity = kk;
                const_var.entry_points.push(Object.assign({
                    "entry_motor_name": currentObjData.entry_motor_name,
                    "entry_motor": currentObjData.entry_motor, 
                     "entry_is_motor": currentObjData.entry_is_motor,
                     "entry_motor_price": currentObjData.entry_motor_price, 
                     "entry_insulated": currentObjData.entry_insulated,
                     "entry_is_insulated": currentObjData.entry_is_insulated,
                     "parent_array_key": parentkey,
                     "child_array_key": childkey,
                     'nested_array_key': nestedkey,
                     'entry_type': compType, 
                     'entry_location': const_var.entry_wall_location[wallName], 
                     'entry_dimension_height': height, 'entry_trim_kit_price': currentObjData.entry_trim_kit_price,
                     'entry_is_trim_kit': currentObjData.entry_is_trim_kit,
                     'entry_dimension_width': width,
                     'uniqueId': newUniqueId,
                     'entry_price': currentObjData.entry_price,
                     'entry_size': is_edit,
                     'name': currentObjData.name,
                     "entry_note": currentObjData.entry_note, 
                     "garage_door_color": currentObjData.garage_door_color,
                     "entry_trim_kit": currentObjData.entry_trim_kit, 
                     "entry_header_seal": currentObjData.entry_header_seal, 
                     "entry_certified": currentObjData.entry_certified, 
                     "entry_chain_hoist": currentObjData.entry_chain_hoist,
                     "entry_is_header_seal": currentObjData.entry_header_seal,
                     "entry_is_certified": currentObjData.entry_certified,
                     "entry_is_chain_hoist": currentObjData.entry_chain_hoist,
                     'entry_position': wallComponent.position,
                     'entry_rotation': wallComponent.rotation, 
                     'entry_chain_hoist_price': currentObjData.entry_chain_hoist_price,
                     'entry_automatic_openers_price': currentObjData.entry_automatic_openers_price, 
                     'entry_header_seal_price': currentObjData.entry_header_seal_price,
                     'entry_component_location': const_var.entry_wall_location[wallName],
                     "entry_automatic_openers": currentObjData.entry_automatic_openers, 
                     "entry_is_automatic_openers": currentObjData.entry_automatic_openers,
                     'entry_garageDoor_color_Obj':  currentObjData.entry_garageDoor_color_Obj ?? const_var.garageDoorColor[params.g_d_c_id],
                     'entry_garageDoor_color_price': currentObjData.entry_garageDoor_color_price ?? const_var.garageDoorColor?.[params.g_d_c_id]?.cost??0,
                     'component_name': compName, "component_wall_name": wallName,
                     'entry_quantity': calQuantity, 
                     'entry_doorNewType': currentObjData.entry_doorNewType,
                     'installation_is_end_wall' : wallCheckForEnd && currentObjData.installation_is_end_wall != null ? currentObjData.installation_is_end_wall : '',
                     'installation_is_side_wall': wallCheckForSide && currentObjData.installation_is_side_wall!=null ? currentObjData.installation_is_side_wall:'',
                     'installation_end_wall_fee':currentObjData.installation_end_wall_fee!=undefined && wallCheckForEnd==true?currentObjData.installation_end_wall_fee:0,'installation_side_wall_fee':currentObjData.installation_side_wall_fee!=undefined && wallCheckForSide==true?currentObjData.installation_side_wall_fee:0,'uniqueName':compName+newUniqueId,'overheadDoorSum':currentObjData.overheadDoorSum!=undefined?currentObjData.overheadDoorSum:undefined, 
                     'is_breezeway_frameout':isBreezewayFrameOut ? true : false,"is_addedBuilding_location":is_addedBuilding_location
                    }, 
                     doorAddOnsObj
                ));
           

            } else {
                if(parentkey == 'Walk' && params.m_s_n == 9){
                    let tmpObj = {"entry_dimension_width": width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': currentObjData.entry_price, 'entry_size': is_edit, 'name': currentObjData.name, "entry_note": currentObjData.entry_note, "garage_door_color": params.g_d_c, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, 'entry_doorNewType': currentObjData.entry_doorNewType ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,
                    'is_price_updated': currentObjData.is_price_updated,"is_addedBuilding_location":is_addedBuilding_location, "threshold": currentObjData.threshold || false,"threshold_price": currentObjData.threshold_price || 0
                    }
                    let tmpUpdtedObj = currentObjData.legCutFee != undefined ? {...tmpObj, legCutFee: currentObjData.legCutFee} : tmpObj
                    const_var.entry_points.push(tmpUpdtedObj);
                }
                else{
                    let tmpObj = {"entry_dimension_width": width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': currentObjData.entry_price, 'entry_size': is_edit, 'name': currentObjData.name, "entry_note": currentObjData.entry_note, "garage_door_color": params.g_d_c, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, 'entry_doorNewType': currentObjData.entry_doorNewType ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,
                    'is_price_updated': currentObjData.is_price_updated,"is_addedBuilding_location":is_addedBuilding_location
                    }
                    let tmpUpdtedObj = currentObjData.legCutFee != undefined ? {...tmpObj, legCutFee: currentObjData.legCutFee} : tmpObj
                    const_var.entry_points.push(tmpUpdtedObj);
                }
            }

            if (is_edit != undefined && const_var.sum == const_var.hodldEditBuildingData?.entry_points.length) {
                store.dispatch(setPricingForComponent(true, newUniqueId,const_var.entry_points.length-1,'',true));
            }
           
        } else {

            let currentObjData = undefined;
         

            const component = const_var.newComponentArray[parentkey].find(item => item.type == childkey && item.alias_name == nestedkey);
            if (component) {
                const sizedComponent = component.sizes.find(item => item.fixed_sizes?.[0]?.width == componentdimension[0] && item.fixed_sizes?.[0]?.height == componentdimension[1]);
                if (sizedComponent) {
                    currentObjData = sizedComponent;
                    currentObjData.name = componentsize;
                }
            }

            let chkCustomDoor = undefined;
            if (currentObjData == undefined) {
                chkCustomDoor = "Custom Size";
                currentObjData = {}
                currentObjData.addons = [];
                currentObjData.name = componentsize;
                currentObjData.width = componentsize.split("x")[0];
                currentObjData.height = componentsize.split("x")[1];
            }

            let componentPrice = 0;
            let verticalOnSideCost = (currentObjData.fixed_sizes?.[0]?.vertical_side_cost) ? currentObjData.fixed_sizes?.[0]?.vertical_side_cost : 0;
            let finalComponentPrice = const_var.entry_wall_location[wallName].includes('side');
               

    
            if (parentkey == "Garage_Frameout") {
                componentPrice = (finalComponentPrice == true) ? currentObjData.on_side : currentObjData.on_end;
            }
            if (parentkey == "Garage") {
                componentPrice = (finalComponentPrice == true) ? currentObjData.fixed_sizes?.[0]?.side_cost + currentObjData.fixed_sizes?.[0]?.cost : currentObjData.fixed_sizes?.[0]?.cost;
            }
            if (parentkey == "Walk") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ? verticalOnSideCost + currentObjData.fixed_sizes?.[0]?.cost : currentObjData.fixed_sizes?.[0]?.cost : currentObjData.fixed_sizes?.[0]?.cost;
            }
            if (parentkey == "Walk_Frameout") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ?  currentObjData.frameout_cost_side:currentObjData.frameout_cost_side : currentObjData.frameout_cost_end;
            }
            if (parentkey == "Windows") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ?  verticalOnSideCost + currentObjData.fixed_sizes?.[0]?.cost : currentObjData.fixed_sizes?.[0]?.cost : currentObjData.fixed_sizes?.[0]?.cost;
            }
            if (parentkey == "Windows_Frameout") {
                componentPrice = (finalComponentPrice == true) ? (params.p_v_w == true) ? currentObjData.vertical_side_cost + currentObjData.frameout_cost_side : currentObjData.frameout_cost_side : currentObjData.frameout_cost_end;
            }
            if (isNaN((componentPrice)) == true) {
                componentPrice = 0;
            }
            if(parentkey == "Garage_Frameout" )
            {
                currentObjData.name = "Custom";
            }

            
            let is_insulated = false;
            let insulatedPrice = 0;
            let doorAddOnsObj = {};
            let is_motor = false;
            let motorPrice = 0;
            let motorName = "";
            let doornewType = "";
            if (currentObjData.door_type == "overhead_door_door" || currentObjData.door_type == "panel_garage_door_door") {
                const wOPtion = currentObjData.door_add_ons.filter((e) => e.door == 'window_option');
                const doorName = currentObjData.door_type == "overhead_door_door" ?  compName.replace("overhead_door_door_", '') : compName.replace("panel_garage_door_door_", '');
                doornewType = wOPtion[0].category.find((item) => item.category.split(' ').join('_').toLowerCase() == doorName);
                let insulatedObj = currentObjData.door_add_ons.filter((e) => e.door == "insulated");
                if (insulatedObj.length > 0) {
                    is_insulated = insulatedObj[0].category[0].is_cost == '1'? true: false;
                    insulatedPrice = parseFloat(insulatedObj[0].category[0].cost);
                    if ( parentkey =="Garage" && insulatedObj[0].category[0].is_cost == 2){
                        params.insulated = true;
                    }
                }
                if(insulatedObj.length == 0 && params.insulated == true){
                    params.insulated = false
                }
                currentObjData.door_add_ons.filter((e) => {
                    if (e.door == "motor") {
                        is_motor  = e.is_cost == '1';
                        motorName = e.category[0].category;
                        motorPrice = e.category[0].cost;

                        if ( parentkey =="Garage" && e.category[0].is_cost == 2){
                            params.motor = true;
                        }
                    }
                });
                let checkMotor = currentObjData.door_add_ons.find((e) =>e.door == "motor")
                if(checkMotor == undefined && params.motor == true){
                    params.motor = false
                }

                let addOnOptions = currentObjData.door_add_ons.find((e) => e.door == "add_on_options");
                addOnOptions?.category.map((item) => {
                    let addObj = {};
                    
                    if (parentkey =="Garage" && item.is_cost == 2){
                        params[item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = true;
                    }
                    addObj["entry_is_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = item.is_cost == 1? true: false;
                    addObj["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"] = parentOBJ!=undefined && parentOBJ["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"] != undefined ? parentOBJ["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door + "_price"]: item.cost;
                    addObj["entry_" + item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door] = item.category == "Frame Out"? true: params[item.category.replace(/\s/g, '_').toLowerCase() + "_" + addOnOptions.door]
                
                    return addObj;                                                                                                                                                                  
                                                                                                                                                                                         
                }).map((e) => doorAddOnsObj = {...doorAddOnsObj, ...e})
                if(doornewType!='')
                {
                    doorAddOnsObj.entry_overhead_type_name = (doornewType!=undefined)?doornewType.category:'';
                    doorAddOnsObj.entry_overhead_type_price = (doornewType!=undefined)?doornewType.cost:'';
                }
            }

            let trimPrice = 0;
            const degree45 = currentObjData.addons.find(item => item.addon_type === "45_degree");
            let is_trim_kit = degree45 ? degree45.is_show: false;
            let trimkit = pTrimkit ? pTrimkit : (degree45 ? degree45.is_default : false);
            
            if (parentkey == "Garage_Frameout") {
                trimPrice = (currentObjData.dutch_cost != undefined && currentObjData.dutch_cost_side != undefined) ? (finalComponentPrice == true) ? currentObjData.dutch_cost_side : currentObjData.dutch_cost : 0;
            } else {
                trimPrice = is_trim_kit ? degree45.cost : 0;
            }                        

            if(chkCustomDoor=="Custom Size" && currentObjData['is_45_degree_angle']==undefined) {
                is_trim_kit = true;
            }

            const automaticOpenerObj = currentObjData.addons.find(item => item.addon_type === "automatic_openers"); 
            const is_automaticOpener = automaticOpenerObj ? automaticOpenerObj.is_show: false;
            const automaticOpener = automaticOpenerObj ? automaticOpenerObj.is_default: false;
            const automaticOpenerPrice = automaticOpenerObj?.cost;

            const headerSeal = currentObjData.addons.find(item => item.addon_type === "header_seal");
            const headerSealPrice = headerSeal?.cost;
            const chainHoist = currentObjData.addons.find(item => item.addon_type === "chain_hoist");
            const chainHoistPrice = chainHoist?.cost;
            const certified = currentObjData.addons.find(item => item.addon_type === "certified");

            if(chainHoist?.is_default) {
                params.chain_hoist = true;
            }

            if(headerSeal?.is_default) {
                params.header_seal = true;
                if(params.m_s_n == 87) wallComponent.DoorObj.header_seal = true;
            }

            if(certified?.is_default) {
                params.certified_door = true;
                componentPrice =(parseFloat(componentPrice) + parseFloat(certified.cost)).toFixed(2);
            }

            if(automaticOpenerObj?.is_default) {
                params.automatic_openers = true;
            }

            if (params.insulated == true) {
                    componentPrice =(parseFloat(componentPrice) + parseFloat(insulatedPrice)).toFixed(2);
            }                
            
            let newDoorData = const_var.newDoorsArray.filter(data=>data.uniqueId==newUniqueId);
            if(newDoorData.length>0 && (currentObjData.door_type == "overhead_door_door" || currentObjData.door_type == "panel_garage_door_door"))
            {
                newDoorData[0].userData.compName = compName;
            }
            if(parentOBJ!=undefined)
            {
                componentPrice = parentOBJ.entry_price;

                if(parentOBJ.entry_trim_kit_price!=undefined)
                {
                    trimPrice = parentOBJ.entry_trim_kit_price;
                }
                if(parentOBJ.entry_size!=undefined)
                {
                    currentObjData = JSON.parse(JSON.stringify(parentOBJ.entry_size));
                    currentObjData.name = componentsize;
                }
                if (parentkey == "Garage" || parentkey == "Garage_Frameout") {
                    if(wallComponent.DoorObj!=undefined && wallComponent.DoorObj!=null)
                    {
                        if(wallComponent.DoorObj.installation_is_end_wall==undefined)
                        {
                            wallComponent.DoorObj.installation_is_end_wall = parentOBJ.installation_is_end_wall!=undefined && wallCheckForEnd==true?parentOBJ.installation_is_end_wall:'';
                        }
                        if(wallComponent.DoorObj.installation_is_side_wall==undefined)
                        {
                            wallComponent.DoorObj.installation_is_side_wall = parentOBJ.installation_is_side_wall!=undefined && wallCheckForSide==true?parentOBJ.installation_is_side_wall:'';
                        }
                    }
                    // let doorColorPrice = (const_var.garageDoorColor[params.g_d_c_id]?.percentage_of_cost > 0) ? componentPrice * const_var.garageDoorColor[params.g_d_c_id].cost / 100 : const_var.garageDoorColor[params.g_d_c_id].cost;
                    const_var.entry_points.push(Object.assign({"entry_motor_name": parentOBJ.entry_motor_name,
                         "entry_motor": parentOBJ.entry_motor,
                         "entry_is_motor": parentOBJ.entry_is_motor,
                         "entry_motor_price": parentOBJ.entry_motor_price,
                         "entry_insulated": params.insulated,
                         "entry_is_insulated": is_insulated,
                         "parent_array_key": parentkey,
                         "child_array_key": childkey,
                         'nested_array_key': nestedkey,
                         'entry_type': compType,
                         'entry_location': const_var.entry_wall_location[wallName],
                         'entry_dimension_height': height,
                         'entry_trim_kit_price': trimPrice,
                        'entry_is_trim_kit': is_trim_kit,
                         'entry_dimension_width': width,
                         'uniqueId': newUniqueId,
                         'entry_price': componentPrice,
                         'entry_size': currentObjData,
                         'name': componentsize,
                         "entry_note": params.extra_notes,
                         "garage_door_color": params.g_d_c,
                         "entry_trim_kit": trimkit,
                         "entry_header_seal": params.header_seal,
                         "entry_certified": params.certified_door,
                         "entry_chain_hoist": params.chain_hoist,
                         "entry_is_header_seal": params.header_seal,
                         "entry_is_certified": params.certified_door,
                         "entry_is_chain_hoist": params.chain_hoist,
                         'entry_position': wallComponent.position,
                         'entry_rotation': wallComponent.rotation,
                         'entry_chain_hoist_price': parentOBJ.entry_chain_hoist_price,
                         'entry_automatic_openers_price': parentOBJ.entry_automatic_openers_price,
                         'entry_header_seal_price': parentOBJ.entry_header_seal_price,
                         'entry_component_location': const_var.entry_wall_location[wallName],
                         "entry_automatic_openers": params.automatic_openers,
                         "entry_is_automatic_openers": params.automatic_openers,
                         'entry_garageDoor_color_Obj': const_var.garageDoorColor[params.g_d_c_id],
                         'entry_garageDoor_color_price': 0,
                         'component_name': compName,
                         "component_wall_name": wallName,
                         'entry_quantity': calQuantity,
                         "entry_doorNewType": chkCustomDoor,
                        'installation_is_end_wall':parentOBJ.installation_is_end_wall!=undefined && wallCheckForEnd==true?parentOBJ.installation_is_end_wall:'',
                        'installation_is_side_wall':parentOBJ.installation_is_side_wall!=undefined && wallCheckForSide==true?parentOBJ.installation_is_side_wall:'',
                        'installation_end_wall_fee':parentOBJ.installation_end_wall_fee!=undefined && wallCheckForEnd==true?parentOBJ.installation_end_wall_fee:0,
                        'installation_side_wall_fee':parentOBJ.installation_side_wall_fee!=undefined && wallCheckForSide==true?parentOBJ.installation_side_wall_fee:0  ,
                        'uniqueName':compName+newUniqueId,
                        'overheadDoorSum':parentOBJ.overheadDoorSum!=undefined?parentOBJ.overheadDoorSum:undefined,
                         'is_breezeway_frameout':isBreezewayFrameOut ? true: false,
                        "is_addedBuilding_location":is_addedBuilding_location},
                         doorAddOnsObj));
                } else {
                    if(parentkey == 'Walk' && params.m_s_n == 9){
                        const_var.entry_points.push({'entry_dimension_width': width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor  ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,'is_price_updated':parentOBJ.is_price_updated || false,"threshold": /* parentOBJ.threshold */ params.threshold || false,"threshold_price": parentOBJ.threshold_price || 0,"is_addedBuilding_location":is_addedBuilding_location});
                    } else{
                        const_var.entry_points.push({'entry_dimension_width': width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor  ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,'is_price_updated':parentOBJ.is_price_updated || false,"is_addedBuilding_location":is_addedBuilding_location});
                    }
                }            
            } else {
                let newDoorData = const_var.newDoorsArray.filter(data=>data.uniqueId==newUniqueId);
                if(newDoorData.length>0 && currentObjData.door_type == "overhead_door_door"){
                    newDoorData[0].userData.compName = compName;
                }

                let doorColorPrice;            
                if (parentkey == "Garage" || parentkey == "Garage_Frameout") {
                    if(wallComponent.DoorObj!=undefined && wallComponent.DoorObj!=null)
                    {
                        if(wallComponent.DoorObj.installation_is_end_wall==undefined)
                        {
                            wallComponent.DoorObj.installation_is_end_wall = currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'';
                        }
                        if(wallComponent.DoorObj.installation_is_side_wall==undefined)
                        {
                            wallComponent.DoorObj.installation_is_side_wall = currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'';
                        }
                    }
                    const_var.entry_points.push(Object.assign({

                        'uniqueId': newUniqueId, 
                        'name': componentsize, 
                        'entry_type': compType, 
                        'entry_size': currentObjData, 
                        'entry_dimension_width': width, 
                        'entry_dimension_height': height, 
                        "parent_array_key": parentkey, 
                        "child_array_key": childkey, 
                        'nested_array_key': nestedkey, 
                        'entry_location': const_var.entry_wall_location[wallName], 
                        'entry_price': componentPrice, 
                        'entry_position': wallComponent.position, 
                        'entry_rotation': wallComponent.rotation, 
                        'component_name': compName,
                        "component_wall_name": wallName, 
                        'entry_quantity': calQuantity, 
                        "entry_doorNewType": chkCustomDoor,

                        'entry_is_trim_kit': is_trim_kit, 
                        "entry_trim_kit": trimkit,
                        'entry_trim_kit_price': trimPrice,

                        "entry_is_automatic_openers": is_automaticOpener, 
                        'entry_automatic_openers_price': automaticOpenerPrice, 
                        "entry_automatic_openers": automaticOpener, 

                        "entry_motor_name": motorName, 
                        "entry_motor": params.motor, 
                        "entry_is_motor": is_motor, 
                        "entry_motor_price": motorPrice, 

                        "entry_insulated": params.insulated, 
                        "entry_is_insulated": is_insulated,


                        "entry_note": params.extra_notes, 
                        "garage_door_color": params.g_d_c,

                        "entry_is_header_seal": params.header_seal, 
                        "entry_header_seal": params.header_seal, 
                        'entry_header_seal_price': headerSealPrice, 

                        "entry_certified": params.certified_door, 
                        "entry_is_certified": params.certified_door, 
                        
                        "entry_chain_hoist": params.chain_hoist, 
                        "entry_is_chain_hoist": params.chain_hoist, 
                        'entry_chain_hoist_price': chainHoistPrice, 
                                            
                        'entry_component_location': const_var.entry_wall_location[wallName], 

                        'entry_garageDoor_color_Obj': const_var.garageDoorColor[params.g_d_c_id], 
                        'entry_garageDoor_color_price': doorColorPrice, 

                        'installation_is_end_wall':currentObjData.installation_is_end_wall!=undefined && wallCheckForEnd==true?currentObjData.installation_is_end_wall:'',
                        'installation_is_side_wall':currentObjData.installation_is_side_wall!=undefined && wallCheckForSide==true?currentObjData.installation_is_side_wall:'',
                        'installation_end_wall_fee':currentObjData.installation_end_wall_fee!=undefined && wallCheckForEnd==true?currentObjData.installation_end_wall_fee:0,
                        'installation_side_wall_fee':currentObjData.installation_side_wall_fee!=undefined && wallCheckForSide==true?currentObjData.installation_side_wall_fee:0 ,
                        'uniqueName':compName+newUniqueId,'overheadDoorSum':currentObjData.overheadDoorSum!=undefined?currentObjData.overheadDoorSum:undefined,
                        
                        'is_breezeway_frameout':isBreezewayFrameOut ? true: false,
                        "is_addedBuilding_location":is_addedBuilding_location
                    }, doorAddOnsObj));
                } else {
                    if(parentkey == 'Walk' && params.m_s_n == 9){
                        const_var.entry_points.push({'entry_dimension_width': width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor  ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,"threshold": /* parentOBJ.threshold */ params.threshold || false,"threshold_price": currentObjData.threshold_price || 0,"is_addedBuilding_location":is_addedBuilding_location});
                    }
                    else{
                        const_var.entry_points.push({'entry_dimension_width': width, "parent_array_key": parentkey, "child_array_key": childkey, 'nested_array_key': nestedkey, 'entry_type': compType, 'entry_location': const_var.entry_wall_location[wallName], 'uniqueId': newUniqueId, 'entry_price': componentPrice, 'entry_size': currentObjData, 'name': componentsize, "entry_note": params.extra_notes, "entry_trim_kit": false, "entry_certified": false, "entry_automatic_openers": false, "entry_chain_hoist": false, 'entry_position': wallComponent.position, 'entry_rotation': wallComponent.rotation, 'entry_component_location': const_var.entry_wall_location[wallName], 'component_name': compName, "component_wall_name": wallName, 'entry_quantity': calQuantity, "entry_doorNewType": chkCustomDoor  ,'uniqueName':compName+newUniqueId,'is_breezeway_frameout':false,"is_addedBuilding_location":is_addedBuilding_location});
                    }
                }
            }
            store.dispatch(setPricingForComponent(true, newUniqueId,const_var.entry_points.length-1));            
        }        
    } 
    document.querySelector('body').classList.remove('active-modal-loader');
}

export const removeComponentFromWall = (uniqueId) => {
    const restArray = const_var.newDoorsArray.filter((item) => item.uniqueId !== uniqueId);
    const_var.newDoorsArray = restArray;

    const restEntrypoints = const_var.entry_points.filter((item) => item.uniqueId !== uniqueId)
    const_var.entry_points = restEntrypoints;
    cuBuilding.cP();
}

function setRaycaster(event) {
    const rect = const_var.renderer.domElement.getBoundingClientRect();
    const mouse = new THREE.Vector3();
    mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = 2 * -((event.clientY - rect.top) / rect.height) + 1;

    const_var.raycaster.setFromCamera(mouse, const_var.camera);
}

export function getIntersectedObject(event, objects) {
    setRaycaster(event);
    return const_var.raycaster.intersectObject(objects);
}

export function getIntersectedObjects(event, arr) {
    setRaycaster(event);
    return const_var.raycaster.intersectObjects(arr, true);
}

export function updateDoorIconsPos(state, doorWallName, currentId) {
    const rect = const_var.renderer.domElement.getBoundingClientRect();
    const doorWindowIconsPos = [];
    state.const_var.newDoorsArray.forEach((door) => {
        if (door.userData.editIconPos && door.userData.wallName === doorWallName) {
            let vector = door.localToWorld(door.userData.editIconPos.clone());
            vector.project(state.const_var.camera);
            vector.x = (1 + vector.x) / 2 * rect.width;
            vector.y = (1 - vector.y) / 2 * rect.height;          
            doorWindowIconsPos.push({ uniqueId: door.uniqueId, display: currentId === door.uniqueId ? 'flex' : 'none', top: `${Math.round(vector.y)}px`, left: `${Math.round(vector.x)}px` });
        }
    })


    return doorWindowIconsPos;
}

export const bBmFd = (Val) => {
    if (const_var.c_h_d_M_l === false) {
        const_var.isShowDoorwindowmobile = true;
        const_var.c_h_d_M_l = true;
        return false;
    }
};

export const wallnameBySec = {
    c_b_f_w: "center",
    c_b_l_w: "center",
    c_b_r_w: "center",
    c_b_b_w: "center",
    F_S_L_R_W: "center",
    c_b_f_s_w: "center",
    c_b_b_s_w: "center",
    c_b_l_s_w: "center",
    c_b_r_s_w: "center",
    c_b_f_s_l_w: "center",
    c_b_f_s_r_w: "center",
    c_b_f_s_b_w: "center",
    c_b_l_s_f_w: "center",
    c_b_l_s_b_w: "center",
    c_b_l_s_r_w: "center",
    c_b_r_s_f_w: "center",
    c_b_r_s_b_w: "center",
    c_b_r_s_l_w: "center",
    L_S_F_W_VT: "center",
    L_S_F_2W_VT: "center",
    L_S_B_W_VT: "center",
    L_S_B_2W_VT: "center",
    R_S_F_W_VT: "center",
    R_S_F_2W_VT: "center",
    R_S_B_W_VT: "center",
    R_S_B_2W_VT: "center",

    L_L_F_W: "leftlean",
    L_L_B_W: "leftlean",
    L_L_L_W: "leftlean",
    L_L_L_S_W: "leftlean",
    L_L_R_S_W: "leftlean",
    L_L_F_S_W: "leftlean",
    L_L_B_S_W: "leftlean",
    
    G_L_L_R_W: "gableLeftLean",
    G_L_L_L_W: "gableLeftLean",
    G_L_L_F_W: "gableLeftLean",
    G_L_L_B_W: "gableLeftLean",
    G_L_L_B_S_F_W: "gableLeftLean",
    G_L_L_R_S_W: "gableLeftLean",
    G_L_L_L_S_W: "gableLeftLean",
    G_L_L_F_S_W: "gableLeftLean",
    G_L_L_B_S_W: "gableLeftLean",

    R_L_R_S_W: "rightlean",
    R_L_L_S_W: "rightlean",
    R_L_F_S_W: "rightlean",
    R_L_B_S_W: "rightlean",
    R_L_F_W: "rightlean",
    R_L_B_W: "rightlean",
    R_L_R_W: "rightlean",

    G_R_L_R_W: "gableRightLean",
    G_R_L_L_W: "gableRightLean",
    G_R_L_F_W: "gableRightLean",
    G_R_L_B_W: "gableRightLean",
    G_R_L_B_S_F_W: "gableRightLean",
    G_R_L_R_S_W: "gableRightLean",
    G_R_L_L_S_W: "gableRightLean",
    G_R_L_F_S_W: "gableRightLean",
    G_R_L_B_S_W: "gableRightLean",

    F_L_L_W: "frontlean",
    F_L_R_W: "frontlean",
    F_L_F_W: "frontlean",
    F_L_F_S_W: "frontlean",
    F_L_B_S_W: "frontlean",
    F_L_R_S_W: "frontlean",
    F_L_L_S_W: "frontlean",
    
    G_F_L_R_W: "gableFrontLean",
    G_F_L_L_W: "gableFrontLean",
    G_F_L_F_W: "gableFrontLean",
    G_F_L_B_W: "gableFrontLean",
    G_F_L_R_S_W: "gableFrontLean",
    G_F_L_L_S_W: "gableFrontLean",
    G_F_L_F_S_W: "gableFrontLean",
    G_F_L_B_S_W: "gableFrontLean",

    B_L_S_W: "backlean",
    B_L_B_W: "backlean",
    B_L_F_W: "backlean",
    B_L_F_S_W: "backlean",
    B_L_B_S_W: "backlean",
    B_L_L_S_W: "backlean",
    B_L_R_S_W: "backlean",
    
    G_B_L_R_W: "gableBackLean",
    G_B_L_L_W: "gableBackLean",
    G_B_L_F_W: "gableBackLean",
    G_B_L_B_W: "gableBackLean",
    G_B_L_R_S_W: "gableBackLean",
    G_B_L_L_S_W: "gableBackLean",
    G_B_L_F_S_W: "gableBackLean",
    G_B_L_B_S_W: "gableBackLean",

}

export const wallNameByStorageSec = {
    c_b_f_s_w: "center-storage-back",
    c_b_b_s_w: "center-storage-back",
    c_b_l_s_w: "center-storage-back",
    c_b_r_s_w: "center-storage-back",
    c_b_f_s_l_w: "center-storage-front",
    c_b_f_s_r_w: "center-storage-front",
    c_b_f_s_b_w: "center-storage-front",
    c_b_l_s_f_w: "center-storage-left",
    c_b_l_s_b_w: "center-storage-left",
    c_b_l_s_r_w: "center-storage-left",
    c_b_r_s_f_w: "center-storage-right",
    c_b_r_s_b_w: "center-storage-right",
    c_b_r_s_l_w: "center-storage-right",
  

    L_L_L_S_W: "leftlean-storage",
    L_L_R_S_W: "leftlean-storage",
    L_L_F_S_W: "leftlean-storage",
    L_L_B_S_W: "leftlean-storage",

  
    G_L_L_R_S_W: "gable-left-lean-storage",
    G_L_L_L_S_W: "gable-left-lean-storage",
    G_L_L_F_S_W: "gable-left-lean-storage",
    G_L_L_B_S_W: "gable-left-lean-storage",

    R_L_R_S_W: "rightlean-storage",
    R_L_L_S_W: "rightlean-storage",
    R_L_F_S_W: "rightlean-storage",
    R_L_B_S_W: "rightlean-storage",

   
    G_R_L_R_S_W: "gable-right-lean-storage",
    G_R_L_L_S_W: "gable-right-lean-storage",
    G_R_L_F_S_W: "gable-right-lean-storage",
    G_R_L_B_S_W: "gable-right-lean-storage",

    F_L_F_S_W: "frontlean-storage",
    F_L_B_S_W: "frontlean-storage",
    F_L_R_S_W: "frontlean-storage",
    F_L_L_S_W: "frontlean-storage",
    
    G_F_L_R_S_W: "gable-front-lean-storage",
    G_F_L_L_S_W: "gable-front-lean-storage",
    G_F_L_F_S_W: "gable-front-lean-storage",
    G_F_L_B_S_W: "gable-front-lean-storage",

    B_L_F_S_W: "backlean-storage",
    B_L_B_S_W: "backlean-storage",
    B_L_L_S_W: "backlean-storage",
    B_L_R_S_W: "backlean-storage",
    
    G_B_L_R_S_W: "gable-back-lean-storage",
    G_B_L_L_S_W: "gable-back-lean-storage",
    G_B_L_F_S_W: "gable-back-lean-storage",
    G_B_L_B_S_W: "gable-back-lean-storage",
}

export const cameraFocusOnWall = (store, wall) => {
    const x = 0;
    const y = params.p_h / 2;
    const z = 0;
    const d = 30;
    const fvalue = 4.51/(window.innerWidth / window.innerHeight);
    
    switch (wall) {
        case "c_b_f_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: params.p_d / 2 + (fvalue * params.p_w) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: x, y: y, z: params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        case "c_b_b_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: x, y, z: -params.p_d / 2 - (fvalue * params.p_w) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: x, y: y, z: -params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        case "c_b_l_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 - (fvalue * params.p_d), y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.p_w / 2, y: y, z: z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        case "c_b_r_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + (fvalue * params.p_d), y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2, y: y, z: z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        // Free standing Lean-to Right Wall
        case "F_S_L_R_W":
            if (store.isFullyEnclosedCheckedForRightLeanTo === false) {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + d, y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            } else {
                new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w - 1, y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            }
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building left storage front wall
        case "c_b_l_s_f_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w - params.cB_addStorage_left) / 2, y, z: params.p_d / 2 + getCamDstForSelectedWall(Math.max(params.p_w, params.p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w - params.cB_addStorage_left) / 2, y: y, z: params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building left storage back wall
        case "c_b_l_s_b_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w - params.cB_addStorage_left) / 2, y, z: -params.p_d / 2 - getCamDstForSelectedWall(Math.max(params.p_w, params.p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w - params.cB_addStorage_left) / 2, y, z: -params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building left storage right wall
        case "c_b_l_s_r_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: - params.p_w / 2 + Number(params.cB_addStorage_left) + (fvalue * params.p_d), y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: - params.p_w / 2 + Number(params.cB_addStorage_left), y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building right storage front wall
        case "c_b_r_s_f_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w - params.cB_addStorage_right) / 2, y, z: params.p_d / 2 + getCamDstForSelectedWall(Math.max(params.p_w, params.p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w - params.cB_addStorage_right) / 2, y, z: params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building right storage back wall
        case "c_b_r_s_b_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w - params.cB_addStorage_right) / 2, y, z: -params.p_d / 2 - getCamDstForSelectedWall(Math.max(params.p_w, params.p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w - params.cB_addStorage_right) / 2, y, z: -params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building right storage left wall
        case "c_b_r_s_l_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 - Number(params.cB_addStorage_right) - (fvalue * params.p_d), y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 - Number(params.cB_addStorage_right), y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building back storage front wall
        case "c_b_f_s_w":
            new TWEEN.Tween(const_var.camera.position).to({ x, y, z: -params.p_d / 2 + parseInt(params.p_u_t) + (fvalue * params.p_w) + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x, y, z: -params.p_d / 2 + parseInt(params.p_u_t) + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
            
        //center building back storage Back wall
        case "c_b_b_s_w":
            new TWEEN.Tween(const_var.camera.position).to({ x, y, z: -params.p_d / 2 - (fvalue * params.p_w) + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x, y, z: -params.p_d / 2 + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building back storage left wall
        case "c_b_l_s_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 - (fvalue * params.p_u_t + d / 2), y, z: -(params.p_d - params.p_u_t) / 2 + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.p_w / 2, y, z: -(params.p_d - params.p_u_t) / 2 + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building back storage right wall
        case "c_b_r_s_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + (fvalue * params.p_u_t + d / 2), y, z: -(params.p_d - params.p_u_t)/2 + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2, y, z: -(params.p_d - params.p_u_t) / 2 + params.endStoragePositionZ }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //center building front storage left wall
        case "c_b_f_s_l_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: x - d, y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building front storage right wall
        case "c_b_f_s_r_w":
            new TWEEN.Tween(const_var.camera.position).to({ x: x + d, y, z }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;

        //center building front storage back wall
        case "c_b_f_s_b_w":
            new TWEEN.Tween(const_var.camera.position).to({ x, y, z: -params.p_d / 2 + Number(params.p_u_t) / 2}, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start()
            const_var.controls.target.copy({x: x, y: y, z: z});
            break;
        //Left lean side wall
        case "L_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 - params.lean_p_w - getCamDstForSelectedWall(Math.max(params.lean_p_d, params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.p_w / 2 - params.lean_p_w, y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left lean front wall
        case "L_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w) / 2, y: params.lean_p_h / 2, z: getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)) + params.lean_p_d / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + params.lean_p_w) / 2, y: params.lean_p_h / 2, z: params.lean_p_d / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left lean back wall
        case "L_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w) / 2, y: params.lean_p_h / 2, z: -getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)) - params.lean_p_d / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + params.lean_p_w) / 2, y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left Gable Lean left wall
        case "G_L_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_d) / 2, y: params.lean_p_h / 2, z: -params.lean_p_w / 2 + params.lean_p_pos - getCamDstForSelectedWall(Math.max(params.lean_p_d, params.lean_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + params.lean_p_d) / 2, y: params.lean_p_h / 2, z: -params.lean_p_w / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Left Gable Lean right wall
        case "G_L_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_d) / 2, y: params.lean_p_h / 2, z: params.lean_p_w / 2 + params.lean_p_pos + getCamDstForSelectedWall(Math.max(params.lean_p_d, params.lean_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + params.lean_p_d) / 2, y: params.lean_p_h / 2, z: params.lean_p_w / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Left Gable Lean front wall
        case "G_L_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w / 2 + params.lean_p_d) - getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w / 2 + params.lean_p_d), y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Left Gable Lean back wall
        case "G_L_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 + getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.p_w / 2, y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back lean side wall
        case "B_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: - params.p_d / 2 - params.leanB_p_w - getCamDstForSelectedWall(Math.max(params.leanB_p_d, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: - params.p_d / 2 - params.leanB_p_w }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back lean left wall
        case "B_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_d / 2 + params.leanB_p_pos - getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_d / 2 + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back lean right wall
        case "B_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_d / 2 + params.leanB_p_pos + getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: - (params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_d / 2 + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back Gable Lean left wall
        case "G_B_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_w / 2 + params.leanB_p_pos + getCamDstForSelectedWall(Math.max(params.leanB_p_d, params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_w / 2 + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Back Gable Lean right wall
        case "G_B_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_w / 2 + params.leanB_p_pos - getCamDstForSelectedWall(Math.max(params.leanB_p_d, params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_w / 2 + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Back Gable Lean front wall
        case "G_B_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - params.leanB_p_d - getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - params.leanB_p_d }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Back Gable Lean back wall
        case "G_B_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 + getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;


        //Front lean side wall
        case "F_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.leanF_p_w + getCamDstForSelectedWall(Math.max(params.leanF_p_d, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.leanF_p_w }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front lean left wall
        case "F_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_d / 2 + params.leanF_p_pos - getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_d / 2 + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front lean right wall
        case "F_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_d / 2 + params.leanF_p_pos + getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2  }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_d / 2 + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front Gable Lean left wall
        case "G_F_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_w / 2 + params.leanF_p_pos - getCamDstForSelectedWall(Math.max(params.leanF_p_d, params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_w / 2 + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Front Gable Lean right wall
        case "G_F_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_w / 2 + params.leanF_p_pos + getCamDstForSelectedWall(Math.max(params.leanF_p_d, params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_w / 2 + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_d) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Front Gable Lean front wall
        case "G_F_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.leanF_p_d + getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.leanF_p_d }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Front Gable Lean back wall
        case "G_F_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 - getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right lean side wall
        case "R_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w + getCamDstForSelectedWall(Math.max(params.leanR_p_d, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + params.leanR_p_w, y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            const_var.controls.target.copy({x: x, y: params.leanR_p_h / 2, z: params.leanR_p_pos});
            break;

        //Right lean back wall
        case "R_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.lean_p_w) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.leanR_p_pos - getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w + params.lean_p_w) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right Lean front wall
        case "R_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.lean_p_w) / 2, y: params.leanR_p_h / 2, z: params.leanR_p_d / 2 + params.leanR_p_pos + getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w + params.lean_p_w) / 2, y: params.leanR_p_h / 2, z: params.leanR_p_d / 2 + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right Gable Lean left wall
        case "G_R_L_L_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.leanR_p_d) / 2, y: params.leanR_p_h / 2, z: params.leanR_p_w / 2 + params.leanR_p_pos + getCamDstForSelectedWall(Math.max(params.leanR_p_d, params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w + params.leanR_p_d) / 2, y: params.leanR_p_h / 2, z: params.leanR_p_w / 2 + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Right Gable Lean right wall
        case "G_R_L_R_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.leanR_p_d) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_w / 2 + params.leanR_p_pos - getCamDstForSelectedWall(Math.max(params.leanR_p_d, params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w + params.leanR_p_d) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_w / 2 + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Right Gable Lean front wall
        case "G_R_L_F_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_d + getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + params.leanR_p_d, y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Right Gable Lean back wall
        case "G_R_L_B_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 - getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2, y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left lean Storage Front wall
        case "L_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w) / 2, y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + parseInt(params.add_storage) + params.lean_p_pos + params.leftLeanStoragePosition + getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + params.lean_p_w) / 2, y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + parseInt(params.add_storage) + params.lean_p_pos + params.leftLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left lean Storage Back wall
        case "L_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + params.lean_p_w)/ 2, y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + params.lean_p_pos + params.leftLeanStoragePosition - getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x:-(params.p_w + params.lean_p_w)/ 2, y: params.lean_p_h / 2, z:  -params.lean_p_d / 2 + params.lean_p_pos + params.leftLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left lean Storage Left wall
        case "L_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w / 2) - params.lean_p_w - getCamDstForSelectedWall(Math.max(parseInt(params.add_storage), params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + params.add_storage / 2 + params.leftLeanStoragePosition + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w / 2) - params.lean_p_w, y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + params.add_storage / 2 + params.leftLeanStoragePosition + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left Lean Storage Right wall
        case "L_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w / 2) + getCamDstForSelectedWall(Math.max(parseInt(params.add_storage), params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + params.add_storage / 2 + params.leftLeanStoragePosition + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w / 2), y: params.lean_p_h / 2, z: -params.lean_p_d / 2 + params.add_storage / 2 + params.leftLeanStoragePosition + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Left Gable Lean Storage left wall
        case "G_L_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + parseInt(params.add_storage)) / 2 - params.leftLeanStoragePosition, y: params.lean_p_h / 2, z: -params.lean_p_w / 2 + params.lean_p_pos - getCamDstForSelectedWall(Math.max(params.add_storage, params.lean_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + parseInt(params.add_storage)) / 2 - params.leftLeanStoragePosition, y: params.lean_p_h / 2, z: -params.lean_p_w / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Left Gable Lean Storage right wall
        case "G_L_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w + parseInt(params.add_storage)) / 2 - params.leftLeanStoragePosition, y: params.lean_p_h / 2, z: params.lean_p_w / 2 + params.lean_p_pos + getCamDstForSelectedWall(Math.max(params.add_storage, params.lean_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w + parseInt(params.add_storage)) / 2 - params.leftLeanStoragePosition, y: params.lean_p_h / 2, z: params.lean_p_w / 2 + params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Left Gable Lean Storage front wall
        case "G_L_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -(params.p_w / 2 + parseInt(params.add_storage)) - params.leftLeanStoragePosition - getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -(params.p_w / 2 + parseInt(params.add_storage)) - params.leftLeanStoragePosition, y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Left Gable Lean Storage back wall
        case "G_L_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.p_w / 2 - params.leftLeanStoragePosition + getCamDstForSelectedWall(Math.max(params.lean_p_w, params.lean_p_h * 1.5)), y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.p_w /  2- params.leftLeanStoragePosition, y: params.lean_p_h / 2, z: params.lean_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right lean Storage Front wall
        case "R_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.leanR_p_w) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition + params.leanR_p_pos + getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w + params.leanR_p_w) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Right lean Storage Back wall
        case "R_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: (params.p_w + params.leanR_p_w) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.rightLeanStoragePosition + params.leanR_p_pos - getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: (params.p_w + params.leanR_p_w) / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.rightLeanStoragePosition + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right lean Storage Left wall
        case "R_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 - getCamDstForSelectedWall(Math.max(params.add_storage_right, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.add_storage_right / 2 + params.rightLeanStoragePosition + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.add_storage_right / 2 + params.rightLeanStoragePosition + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right Lean Storage Right wall
        case "R_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.leanR_p_w + getCamDstForSelectedWall(Math.max(params.add_storage_right, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.add_storage_right / 2 + params.rightLeanStoragePosition + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + params.leanR_p_w, y: params.leanR_p_h / 2, z: -params.leanR_p_d / 2 + params.add_storage_right / 2 + params.rightLeanStoragePosition + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right Gable Lean Storage left wall
        case "G_R_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + parseInt(params.add_storage_right) / 2 + params.rightLeanStoragePosition, y: params.leanR_p_h / 2, z: params.leanR_p_w / 2 + params.leanR_p_pos + getCamDstForSelectedWall(Math.max(parseInt(params.add_storage_right), params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + parseInt(params.add_storage_right) / 2 + params.rightLeanStoragePosition, y: params.leanR_p_h / 2, z: params.leanR_p_w / 2 + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Right Gable Lean Storage right wall
        case "G_R_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + parseInt(params.add_storage_right) / 2 + params.rightLeanStoragePosition, y: params.leanR_p_h / 2, z: -params.leanR_p_w / 2 + params.leanR_p_pos - getCamDstForSelectedWall(Math.max(parseInt(params.add_storage_right), params.leanR_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + parseInt(params.add_storage_right) / 2 + params.rightLeanStoragePosition, y: params.leanR_p_h / 2, z: -params.leanR_p_w / 2 + params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        
        //Right Gable Lean Storage front wall
        case "G_R_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition + getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + parseInt(params.add_storage_right) + params.rightLeanStoragePosition, y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        
        //Right Gable Lean Storage back wall
        case "G_R_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.p_w / 2 + params.rightLeanStoragePosition - getCamDstForSelectedWall(Math.max(params.leanR_p_w, params.leanR_p_h * 1.5)), y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.p_w / 2 + params.rightLeanStoragePosition, y: params.leanR_p_h / 2, z: params.leanR_p_pos }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back lean Storage Front wall
        case "B_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_d / 2 + params.add_storage_back / 2 + params.backLeanStoragePosition + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - params.leanB_p_w - getCamDstForSelectedWall(Math.max(params.add_storage_back, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_d / 2 + params.add_storage_back / 2 + params.backLeanStoragePosition + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - params.leanB_p_w }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back lean Storage Back wall
        case "B_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_d / 2 + params.add_storage_back / 2 + params.backLeanStoragePosition + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 + getCamDstForSelectedWall(Math.max(params.add_storage_back, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_d / 2 + params.add_storage_back / 2 + params.backLeanStoragePosition + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back Lean Storage Left wall
        case "B_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_d / 2 + parseInt(params.add_storage_back) + params.backLeanStoragePosition + params.leanB_p_pos + getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_d / 2 + parseInt(params.add_storage_back) + params.backLeanStoragePosition + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back Lean Storage Right wall
        case "B_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_d / 2 + params.backLeanStoragePosition + params.leanB_p_pos - getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_d / 2 + params.backLeanStoragePosition + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + params.leanB_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Back Gable Storage Lean left wall
        case "G_B_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_w / 2 + params.leanB_p_pos + getCamDstForSelectedWall(Math.max(parseInt(params.add_storage_back), params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + parseInt(params.add_storage_back)) / 2 - params.backLeanStoragePosition}, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_w / 2 + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + parseInt(params.add_storage_back)) / 2 - params.backLeanStoragePosition}, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Back Gable Storage Lean right wall
        case "G_B_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanB_p_w / 2 + params.leanB_p_pos - getCamDstForSelectedWall(Math.max(parseInt(params.add_storage_back), params.leanB_p_h * 1.5)), y: params.leanB_p_h / 2, z: -(params.p_d + parseInt(params.add_storage_back)) / 2 - params.backLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanB_p_w / 2 + params.leanB_p_pos, y: params.leanB_p_h / 2, z: -(params.p_d + parseInt(params.add_storage_back)) / 2 - params.backLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Back Gable Storage Lean front wall
        case "G_B_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - parseInt(params.add_storage_back) - params.backLeanStoragePosition - getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - parseInt(params.add_storage_back) - params.backLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Back Gable Storage Lean back wall
        case "G_B_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - params.backLeanStoragePosition + getCamDstForSelectedWall(Math.max(params.leanB_p_w, params.leanB_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanB_p_pos, y: params.leanB_p_h / 2, z: -params.p_d / 2 - params.backLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front lean Storage Front wall
        case "F_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_d / 2 + params.add_storage_front / 2 + params.frontLeanStoragePosition + params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.leanF_p_w + getCamDstForSelectedWall(Math.max(params.add_storage_front, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_d / 2 + params.add_storage_front / 2 + params.frontLeanStoragePosition + params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.leanF_p_w }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front lean Storage Back wall
        case "F_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_d / 2 + params.add_storage_front / 2 + params.frontLeanStoragePosition + params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 - getCamDstForSelectedWall(Math.max(params.add_storage_front, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_d / 2 + params.add_storage_front / 2 + params.frontLeanStoragePosition + params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front Lean Storage Left wall
        case "F_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_d / 2 + params.frontLeanStoragePosition + params.leanF_p_pos - getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_d / 2 + params.frontLeanStoragePosition + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front Lean Storage Right wall
        case "F_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + params.leanF_p_pos + getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + params.leanF_p_w) / 2 }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;

        //Front Gable Lean Storage left wall
        case "G_F_L_L_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: -params.leanF_p_w / 2 + params.leanF_p_pos - getCamDstForSelectedWall(Math.max(parseInt(params.add_storage_front), params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + parseInt(params.add_storage_front)) / 2 + params.frontLeanStoragePosition}, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: -params.leanF_p_w / 2 + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + parseInt(params.add_storage_front)) / 2 + params.frontLeanStoragePosition}, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Front Gable Lean Storage right wall
        case "G_F_L_R_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_w / 2 + params.leanF_p_pos + getCamDstForSelectedWall(Math.max(parseInt(params.add_storage_front), params.leanF_p_h * 1.5)), y: params.leanF_p_h / 2, z: (params.p_d + parseInt(params.add_storage_front)) / 2 + params.frontLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_w / 2 + params.leanF_p_pos, y: params.leanF_p_h / 2, z: (params.p_d + parseInt(params.add_storage_front)) / 2 + params.frontLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Front Gable Lean Storage front wall
        case "G_F_L_F_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        //Front Gable Lean Storage back wall
        case "G_F_L_B_S_W":
            new TWEEN.Tween(const_var.camera.position).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.frontLeanStoragePosition - getCamDstForSelectedWall(Math.max(params.leanF_p_w, params.leanF_p_h * 1.5)) }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            new TWEEN.Tween(const_var.controls.target).to({ x: params.leanF_p_pos, y: params.leanF_p_h / 2, z: params.p_d / 2 + params.frontLeanStoragePosition }, 1000).easing(TWEEN.Easing.Quadratic.InOut).yoyo(true).start();
            break;
        default:
    }


    const_var.controls.update();
    
    animate()

    function animate() {
        requestAnimationFrame(animate)
        TWEEN.update()
    }
   
};


export const handleComponentPosition = (wallName,lean) =>{
    let filterRecord = const_var.entry_points.filter(data => data.component_wall_name == wallName);
        if(filterRecord.length>0)
        {
            let comName = const_var.scene.getObjectByName(filterRecord[0].component_name + filterRecord[0].uniqueId);
            let pos = comName.position.z;
            if(params.leantoAlignmentLeft=="2")
            {
                pos = (comName.position.z>0)?-comName.position.z:Math.abs(comName.position.z);
            }if(params.leantoAlignmentLeft=="3")
            {
                pos = (comName.position.z>0)?-comName.position.z:Math.abs(comName.position.z);
            }
            comName.position.set(comName.position.x, comName.position.y, pos);
            
        }
        
}


export const RemoveDoorComponent = (unique, compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, trimkit, is_edit,isBreezewayFrame,isChangePos) => {
    // console.log('cmpReducer : RemoveDoorCmp -> ', {unique, compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_trim, is_edit,isBreezewayFrame,isChangePos});
    let selectedCmpPosX = 0;
    let selectedCmpPosY = 0;
        if(is_edit && componentsize.entry_position!=undefined) {
            selectedCmpPosX = componentsize.entry_position.positionX;
            selectedCmpPosY = componentsize.entry_position.positionY;
        } else {
            const selectedComponent = const_var.newDoorsArray.find(s => s.uniqueId === unique)
            // console.log(selectedComponent,'cmpReducer : RemoveDoorCmp -> ', {unique, compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_trim, is_edit,isBreezewayFrame,isChangePos});
   
            selectedCmpPosX = selectedComponent.positionX;
            selectedCmpPosY = selectedComponent.positionY;
        }

        for (var i = 0; i < const_var.newDoorsArray.length; i++) {
            if (const_var.newDoorsArray[i].uniqueId == unique) {
                const_var.removed_door_wallname = const_var.newDoorsArray[i].userData.wallName;
                const_var.removed_door = const_var.newDoorsArray.splice(i, 1)[0];
            }
        }

        const_var.entry_points.map((val, i) => {
            if (val.uniqueId == unique) {
                const_var.removed_door_entry_point = const_var.entry_points.splice(i, 1)[0];
            }
        })
        cuBuilding.cP();
        params.wallPos = "Select";

        if (wall == undefined) wall = const_var.removed_door_wallname;
        let checkWallValue = const_var.checkWallClose[wall];
        var trimCalor = params.p_t_c.replace("#", "0x");
        if(checkWallValue == 'utility') {
          trimCalor = params.p_t_c.replace("#", "0x");
        } else {
          if (params[checkWallValue]=='Open') {
            trimCalor = '0x94989B';
          }
       }
        

        if (componentsize != undefined) {
            let prom = Promise.resolve(undefined);
            const newfuncforDoorWindows = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,undefined,isBreezewayFrame, unique, selectedCmpPosX, selectedCmpPosY, isChangePos) => {
                            prom = prom.then(async(res, rej) => {
                                const ans = await loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,undefined,isBreezewayFrame, unique, selectedCmpPosX, selectedCmpPosY, isChangePos, undefined, trimkit);
                            });                        
                        } 

                        newfuncforDoorWindows(compType, compName, wall, componentsize, parentkey, childkey, nestedkey, entry_rotation, entry_position, is_edit,undefined,isBreezewayFrame, unique, selectedCmpPosX, selectedCmpPosY, isChangePos);
            
        }
}

export const removeAlltheComponent = (flag) => {
    if(flag == true){
        const_var.newDoorsArray = const_var.newDoorsArray.filter((val, i) => {
            if (val.nested_array_key.includes("Overhead")) {
                const_var.scene.remove(const_var.scene.getObjectByName(val.component_name + val.uniqueId));
                return false;
            }
            return true;
        });
        const_var.entry_points = const_var.entry_points.filter((val, i) => {
            if (val.child_array_key.includes("overhead_door_door")) {
                return false;
            }
            return true;
        });
        cuBuilding.cP();
    }else{

        if (const_var.entry_points.length > 0) {
            const_var.entry_points.map((val, i) => {
                const_var.scene.remove(const_var.scene.getObjectByName(val.component_name + val.uniqueId));
                const_var.newDoorsArray.splice(i, 1);
            })
            const_var.newDoorsArray = [];
            const_var.cupolas = [];
            const_var.b_d_g_b_O_cN = [];
     
            const_var.showComponentEditBox = false;
        }
        if (const_var.entry_points.length > 0) {
                const_var.newDoorsArray=[];
                const_var.entry_points = [];
                const_var.sum = 0;
                cuBuilding.cP();
            }
            if (const_var.cupolas.length > 0) {
                const_var.cupolas = [];
            }
    }
 
}


export const RemovePorchComponent = (Val,newFlag) => { 
    let filterRecordFLF = const_var.entry_points.filter(data => data.component_wall_name == "F_L_F_W");
    let filterRecordBLS = const_var.entry_points.filter(data => data.component_wall_name == "B_L_S_W");
    let filterRecordLLL = const_var.entry_points.filter(data => data.component_wall_name == "L_L_L_W");
    let filterRecordRLR = const_var.entry_points.filter(data => data.component_wall_name == "R_L_R_W");
    let compWidth;

    if(filterRecordFLF.length > 0){
        for (let i = 0; i < filterRecordFLF.length; i++) {  
            if(filterRecordFLF[i].component_wall_name.includes("standard_door") || filterRecordFLF[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (Number(filterRecordFLF[i].name.split('x')[0]))*1
            }else{
                compWidth = (Number(filterRecordFLF[i].name.split('x')[0]))*0.084
            }
            if(params.add_left_front_lean_porch == false){
                if(filterRecordFLF[i].entry_position.x - (compWidth/2) < -(params.p_w/2)){
                   RemoveDoorComponent(filterRecordFLF[i].uniqueId, filterRecordFLF[i].component_name);
                }
                
            }

            if(params.add_right_front_lean_porch == false){
                if(filterRecordFLF[i].entry_position.x + (compWidth/2) > (params.p_w/2)){
                   RemoveDoorComponent(filterRecordFLF[i].uniqueId, filterRecordFLF[i].component_name);
                }
                
            }
        }
    }

    if(filterRecordBLS.length > 0){
        for (let i = 0; i < filterRecordBLS.length; i++) {  
            if(filterRecordBLS[i].component_wall_name.includes("standard_door") || filterRecordBLS[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (filterRecordBLS[i].name.split('x')[0])*1
            }else{
                compWidth = (filterRecordBLS[i].name.split('x')[0])*0.084
            }
            if(params.add_left_back_lean_porch == false){
                if(filterRecordBLS[i].entry_position.x - (compWidth/2) < -(params.p_w/2)){
                   RemoveDoorComponent(filterRecordBLS[i].uniqueId, filterRecordBLS[i].component_name);
                }
                
            }

            if(params.add_right_back_lean_porch == false){
                if(filterRecordBLS[i].entry_position.x + (compWidth/2) > (params.p_w/2)){
                   RemoveDoorComponent(filterRecordBLS[i].uniqueId, filterRecordBLS[i].component_name);
                }
                
            }
        }
    }

    if(filterRecordLLL.length > 0){
        for (let i = 0; i < filterRecordLLL.length; i++) {  
            if(filterRecordLLL[i].component_wall_name.includes("standard_door") || filterRecordLLL[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (filterRecordLLL[i].name.split('x')[0])*1
            }else{
                compWidth = (filterRecordLLL[i].name.split('x')[0])*0.084
            }
            if(params.add_left_back_lean_porch == false){
                if(filterRecordLLL[i].entry_position.z - (compWidth/2) < -(params.p_d/2)){
                   RemoveDoorComponent(filterRecordLLL[i].uniqueId, filterRecordLLL[i].component_name);
                }
                
            }

            if(params.add_left_front_lean_porch == false){
                if(filterRecordLLL[i].entry_position.z + (compWidth/2) > (params.p_d/2)){
                   RemoveDoorComponent(filterRecordLLL[i].uniqueId, filterRecordLLL[i].component_name);
                }
                
            }
        }
    }

    if(filterRecordRLR.length > 0){
        for (let i = 0; i < filterRecordRLR.length; i++) {  
            if(filterRecordRLR[i].component_wall_name.includes("standard_door") || filterRecordRLR[i].component_wall_name.includes("standard_trim_door")){
                compWidth = (filterRecordRLR[i].name.split('x')[0])*1
            }else{
                compWidth = (filterRecordRLR[i].name.split('x')[0])*0.084
            }
            if(params.add_right_back_lean_porch == false){
                if(filterRecordRLR[i].entry_position.z - (compWidth/2) < -(params.p_d/2)){
                   RemoveDoorComponent(filterRecordRLR[i].uniqueId, filterRecordRLR[i].component_name);
                }
                
            }

            if(params.add_right_front_lean_porch == false){
                if(filterRecordRLR[i].entry_position.z + (compWidth/2) > (params.p_d/2)){
                   RemoveDoorComponent(filterRecordRLR[i].uniqueId, filterRecordRLR[i].component_name);
                }
                
            }
        }
    }

}




export function onResize() {
    let classData = document.getElementsByClassName("buildingcanvas");
    const_var.camera.aspect = classData[0].clientWidth / classData[0].clientHeight;
    const_var.camera.updateProjectionMatrix();
    const_var.renderer.setSize(classData[0].clientWidth, classData[0].clientHeight);
}

function encodeSvgData(svgData) {
    let svgEncodedData = JSON.stringify(svgData);
    let startIndex = svgEncodedData.indexOf("<svg");
    svgEncodedData = svgEncodedData.substring(startIndex);    
    return svgEncodedData;
}

async function myFetch() {
    let floorPromise = new Promise(function(myResolve, myReject) {
        let count = 0;
        function check2DImage() {
            count += 1;
            if (const_var.layout2DMapId === const_var.generated2DMapId || count > 15) {
                myResolve();
            } else {
                setTimeout(check2DImage, 1000);
            }
        }
        setTimeout(check2DImage, 1000);
    });
    await floorPromise.then(function(val) {}, function(val) {});
        const_var.i_g_A_y2d = [];
        if (window.twoDMapReqPng) {
                if(const_var.twoDImageObj.length>0)
                {
                    const_var.twodImageData = [];
                    let two_d_images = []; // ########## Variable for holding 2D image data that has value "is_checked" = true
                    const_var.twoDImageObj.map((val,index)=>{
                        if(val.is_checked==true)
                        {
                            two_d_images.push({ "image": val.image, "image_name": "2D Layout1",'is_checked':val.is_checked });

                            if(const_var.crmSetting.manual_2D_img_count != undefined && !isNaN(const_var.crmSetting.manual_2D_img_count)) {
                                if(two_d_images.length <= parseInt(const_var.crmSetting.manual_2D_img_count)) {
                                    const_var.i_g_A_y2d.push({ "image": val.image, "image_name": "2D Layout1",'is_checked':val.is_checked });
                                }
                            } else {
                                const_var.i_g_A_y2d.push({ "image": val.image, "image_name": "2D Layout1",'is_checked':val.is_checked });
                            }
                        }
                    })
                    const_var.i_g_A_y2d.push({ "image": window.twoDMapAutoPng, "image_name": "2D Layout" });
                    const_var.i_g_A_y2d.push({"type":"html","image":encodeSvgData(window.twoDMapAutoSvg),"image_name":"2D Layout"});  
                    
                }else{
                    const_var.i_g_A_y2d.push({ "image": window.twoDMapAutoPng, "image_name": "2D Layout" });
                    const_var.i_g_A_y2d.push({"type":"html","image":encodeSvgData(window.twoDMapAutoSvg),"image_name":"2D Layout"});  
                    
                }
            }else if (window.twoDMapAutoPng) {
                const_var.i_g_A_y2d.push({ "image": window.twoDMapAutoPng, "image_name": "2D Layout" });
                const_var.i_g_A_y2d.push({"type":"html","image":encodeSvgData(window.twoDMapAutoSvg),"image_name":"2D Layout"});  
                
            } 
        const_var.twodImageData = const_var.twoDImageObj;
}
export const TsCeSot = async (Val, chkIndex,checkImg) => {
    controls.isCheckActiveTab = null
    params.activeWall = "c_b_f_w"
    params.is_translusant = false
    const_var.imageObj = undefined

    if (const_var.isMobileDraw) {

        console.log("mobile version");

        await new Promise((resolve, reject) => {
            makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,const_var.scene);
            
            const d = 25 * 5;
            const positions = [
                { x: params.p_w / 2 + (params.add_right_lean? params.leanR_p_w : 0) + d /4 * 3, y: params.p_h / 2, z: params.p_d / 2 + (params.add_front_lean? params.leanF_p_w : 0) + (params.add_left_lean? params.lean_p_w : 0) + d },
                { x: (params.p_d / 4 * 3 + Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d), y: params.p_h / 2, z: 0 },
                { x: 0, y: params.p_h / 2, z: -(params.p_d / 2 + Math.max(params.add_back_lean ? params.leanB_p_w : 0, params.add_left_lean ? params.lean_p_w : 0, params.add_right_lean ? params.leanR_p_w : 0) + d)},
                { x: -(params.p_d / 4 * 3 + Math.max(params.add_front_lean? params.leanF_p_w : 0, params.add_back_lean? params.leanB_p_w : 0) + d), y: params.p_h / 2, z: 0 },
               
            ];

            if( const_var.i_g_A_y.length == 0){

                const_var.renderer.setSize(1300, 900,false); // Set higher resolution (e.g., Full HD)
                const_var.renderer.setPixelRatio(window.devicePixelRatio/3); // Adjust for device pixel ratio
                const_var.camera.aspect = 1300 /900;
                const_var.camera.updateProjectionMatrix();

                positions.forEach((pos) => {
                    const_var.camera.position.copy(pos);
                    const_var.controls.target.set(0, params.p_h / 2, 0);
                    const_var.controls.update(); 
                    const_var.renderer.render(const_var.scene, const_var.camera)
                    const_var.i_g_A_y.push({"image":const_var.renderer.domElement.toDataURL("image/png")});
                })

                let classData = document.getElementsByClassName("buildingcanvas");
                const_var.camera.aspect = classData[0].clientWidth / classData[0].clientHeight;
                const_var.camera.updateProjectionMatrix();
                const_var.renderer.setSize(classData[0].clientWidth, classData[0].clientHeight);
                const_var.renderer.render(const_var.scene, const_var.camera);

            }

            const_var.proceedToMobileSave = true;

            resolve();
        
        }).then(async(e) => {
            if (const_var.i_g_A_y.length > 0) {
                const_var.CallApionAction = true;
                let settingData = const_var.crmSetting;
                for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                    if(const_var.isManualCapture == false){
                        let name =  ""
                        if(i == 0){
                            name = "Front"
                        }
                        if(i == 1){
                            name = "Right"
                        }
                        if(i == 2){
                            name = "Back"
                        }
                        if(i == 3){
                            name = "Left"
                        }
                        const_var.i_g_A_y[i].image_name = name
                    }
                    if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout") {
                        const_var.i_g_A_y.splice(i, 1);
                    }
                    if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout1" && const_var.i_g_A_y[i].is_checked == false) {
                        const_var.i_g_A_y.splice(i, 1);
                    }
                }
                if (const_var.two_d_layuot.is_active == 1 && const_var.i_g_A_y2d != undefined && const_var.i_g_A_y2d.length > 0) {
                    if (const_var.crmSetting.is_module_name == "quote" && const_var.two_d_layuot.include_in_quote == 1) {
                        const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                    }
                    if (const_var.crmSetting.is_module_name == "order" && const_var.two_d_layuot.include_in_order == 1) {
                        const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                    }
                }
                const formData = await preparePdfImagesPayload(const_var.i_g_A_y);
                return saveOqImageService(formData).then((response) => {
                    if (response.data.status == true && response?.data.failed_images.length<1) {
                        const_var.post_data["pdf_images"] = response.data.group_id;
                        if (const_var.loginSession == true) {
                            store.dispatch(SendBuildingDatatoServer());
                        }else if (const_var.isPublicEdit == true) {
                            store.dispatch(SendBuildingDatatoPublicServer());
                        } else {
                            const_var.showProcessLoaderchk = false;
                            
                            if(const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.saveLatterModal == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.post_data && const_var.post_data.full_name != undefined && const_var.post_data.full_name != '' && const_var.showStateOnly != true){
                                store.dispatch({
                                    type: "onQuoteSubmit",
                                });
                                if(const_var.checkValidate==false){
                                store.dispatch(onQuoteSubmitApi());
                                }
                            }else{
                                var element = document.getElementsByClassName("spinner-active")[0];
                                element?.classList.remove("spinner-active");
                            }
                        }
                    }
                }).catch((error)=>{
                    console.log(error);
                });
            }
        })

    } else {

        makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,const_var.scene);
        if (Val == "print") {
            if(const_var.i_g_A_y.length == 0){
                let prom = Promise.resolve(undefined);
                if(checkImg==undefined)
                  
                    {
                        const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                            prom = prom.then(() => {            
                                store.dispatch(capturebuildingImages(Val, chkIndex))
                            });
                            };
                            
                        newfuncforcapturebuildingImages(Val, chkIndex);
                    }
            }
            if (const_var.i_g_A_y.length == 4) {
                const_var.PrintAlertBox = true;
                const_var.PrintAlertBoxShowButton = true;
                store.dispatch(genratePrintImages(true));
            }
        } else {

            if (const_var.checkCaptuareImage == true) {
                if (const_var.two_d_layuot.is_active == 1 && const_var.crmSetting.is_module_name != "inventory") {
                    await myFetch().then((msg) => {
                    });
                }

                if (const_var.i_g_A_y.length > 0) {
                    const_var.CallApionAction = true;
                    let settingData = const_var.crmSetting;
                    for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                        if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout") {
                            const_var.i_g_A_y.splice(i, 1);
                        }
                        if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout1" && const_var.i_g_A_y[i].is_checked == false) {
                            const_var.i_g_A_y.splice(i, 1);
                        }
                    }
                    if (const_var.two_d_layuot.is_active == 1 && const_var.i_g_A_y2d != undefined && const_var.i_g_A_y2d.length > 0) {
                        if (const_var.crmSetting.is_module_name == "quote" && const_var.two_d_layuot.include_in_quote == 1) {
                            const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                        }
                        if (const_var.crmSetting.is_module_name == "order" && const_var.two_d_layuot.include_in_order == 1) {
                            const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                        }
                    }
                    const formData = await preparePdfImagesPayload(const_var.i_g_A_y);
                    return saveOqImageService(formData).then((response) => {
                        if (response.data.status == true && response.data?.failed_images.length<1) {
                            const_var.post_data["pdf_images"] = response.data.group_id;
                            if (const_var.loginSession == true) {
                                store.dispatch(SendBuildingDatatoServer());
                            }else if (const_var.isPublicEdit == true) {
                                store.dispatch(SendBuildingDatatoPublicServer());
                            } else {
                                const_var.showProcessLoaderchk = false;
                                
                                if(const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.saveLatterModal == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.post_data && const_var.post_data.full_name != undefined && const_var.post_data.full_name != '' && const_var.showStateOnly != true){
                                    store.dispatch({
                                        type: "onQuoteSubmit",
                                    });
                                    if(const_var.checkValidate==false){
                                    store.dispatch(onQuoteSubmitApi());
                                    }
                                }else{
                                    var element = document.getElementsByClassName("spinner-active")[0];
                                    element?.classList.remove("spinner-active");
                                }
                            }
                        }
                    });
                }
            } else {
                    if(const_var.i_g_A_y.length == 0){
                    
                        let prom = Promise.resolve();
                     
                        
                        if(checkImg==undefined)
                        {
                            const newfuncforcapturebuildingImages = (Val, chkIndex) => {
                                prom = prom.then(() => {
                                    // capturebuildingImages(Val, chkIndex);  
                                store.dispatch(capturebuildingImages(Val, chkIndex))

                                });
                            };
                            
                            newfuncforcapturebuildingImages(Val, chkIndex);
                            
                        }
                    }
                    if (const_var.two_d_layuot.is_active == 1 && const_var.crmSetting.is_module_name != "inventory") {
                        await myFetch().then((msg) => {
                        });
                    }
                    if (const_var.i_g_A_y.length == 4 && const_var.checkCaptuareImage == false) {

                        const_var.CallApionAction = true;
                        let settingData = const_var.crmSetting;
                        for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                            if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout") {
                                const_var.i_g_A_y.splice(i, 1);
                            }
                            if (const_var.i_g_A_y[i]!=undefined && const_var.i_g_A_y[i].image_name == "2D Layout1" && const_var.i_g_A_y[i].is_checked == false) {
                                const_var.i_g_A_y.splice(i, 1);
                            }
                        }
                        if (const_var.two_d_layuot.is_active == 1 && const_var.i_g_A_y2d != undefined && const_var.i_g_A_y2d.length > 0) {
                        
                            if (const_var.crmSetting.is_module_name == "quote" && const_var.two_d_layuot.include_in_quote == 1) {
                                const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                            }
                            if (const_var.crmSetting.is_module_name == "order" && const_var.two_d_layuot.include_in_order == 1) {
                                const_var.i_g_A_y = [...const_var.i_g_A_y,...const_var.i_g_A_y2d];
                            }
                        }
                        if(const_var.i_g_A_y.length>0)
                        {
                            for (var i = const_var.i_g_A_y.length - 1; i >= 0; i--) {
                                if (const_var.i_g_A_y[i]==null) {
                                    const_var.i_g_A_y.splice(i, 1);
                                }
                            }
                        }
                        const formData = await preparePdfImagesPayload(const_var.i_g_A_y);
                        return saveOqImageService(formData).then((response) => {
                            if (response.data.status == true && response?.data.failed_images.length<1) {
                                const_var.post_data["pdf_images"] = response.data.group_id;
                                if (const_var.loginSession == true) {
                                    store.dispatch(SendBuildingDatatoServer());
                                }else if (const_var.isPublicEdit == true) {
                                    store.dispatch(SendBuildingDatatoPublicServer());
                                } else {
                                    const_var.showProcessLoaderchk = false;
                                    var element = document.getElementsByClassName("spinner-active")[0];
                                    element?.classList.remove("spinner-active");
                                    if(const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && const_var.saveLatterModal == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false && const_var.post_data && const_var.post_data.full_name != undefined && const_var.post_data.full_name != '' && const_var.showStateOnly != true){
                                        store.dispatch({
                                            type: "onQuoteSubmit",
                                        });
                                        if(const_var.checkValidate==false){
                                        store.dispatch(onQuoteSubmitApi());
                                        }
                                    }
                                }
                                const_var.checkIval = 0;
                                const_var.i_g_A_y = [];
                            }
                        });
                    }

            }
        }
    }
};
async function base64ToFile(base64, filename) {
    const res = await fetch(base64);
    const blob = await res.blob();
    const extension = blob.type.split('/')[1];
    return {file:new File([blob], filename+'.'+extension, { type: blob.type }),ext:extension};
    
}
const preparePdfImagesPayload = async (images) => {
    const formData = new FormData();
    for (let i = 0; i < images.length; i++) {
        const img = images[i];
        if(img.type !== 'html'){
           let file; 
           if(img.image?.startsWith("<svg")){
                file = new Blob([img.image], { type: "image/svg+xml" });
           }
           else{
                const {file: convertedFile} = await base64ToFile(img.image,`${img.image_name}`);
                file = convertedFile;
           }
           formData.append(`pdf_images[${i}][image]`,file);
           formData.append(`pdf_images[${i}][image_name]`,img.image_name);
       }
    }
    const moduleName = const_var.crmSetting.is_module_name === 'inventory'? 'quote': const_var.crmSetting.is_module_name;
    formData.append('module',moduleName);
    return formData;
}


export default componentReducer;

